import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faEye } from '@fortawesome/free-solid-svg-icons';
import { notification } from '../../../commonComponents/Notification/Notification';
import {
  ThumbnailWrapper,
  ThumbnailBox,
  ThumbnailPlaceholder,
  ThumbnailImg,
  ThumbnailEyeBadge,
} from './Styles';

import { OptionThumbnailProps } from './types';

export const OptionThumbnail: React.FC<OptionThumbnailProps> = ({ imageUrl, altText, isDark }) => {
  const [previewOpen, setPreviewOpen] = useState(false);

  const handleDownload = async () => {
    if (!imageUrl) return;
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      const ext = imageUrl.split('.').pop()?.split('?')[0] || 'jpg';
      link.download = `${(altText ?? 'image').replace(/[^a-z0-9]/gi, '_').toLowerCase()}.${ext}`;
      link.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      notification.error('Download failed', 'Unable to download the image. Please try again.', 5);
    }
  };

  return (
    <>
      <ThumbnailWrapper>
        {imageUrl ? (
          <ThumbnailBox $isDark={isDark}>
            <ThumbnailImg src={imageUrl} alt={altText} />
          </ThumbnailBox>
        ) : (
          <ThumbnailPlaceholder $isDark={isDark}>
            <FontAwesomeIcon
              icon={faImage}
              fontSize={20}
              color={isDark ? '#4a5568' : '#c4c4c4'}
            />
          </ThumbnailPlaceholder>
        )}
        {imageUrl && (
          <ThumbnailEyeBadge onClick={(e) => { e.stopPropagation(); setPreviewOpen(true); }}>
            <FontAwesomeIcon icon={faEye} fontSize={9} color="#fff" />
          </ThumbnailEyeBadge>
        )}
      </ThumbnailWrapper>

      {imageUrl && (
        <Modal
          open={previewOpen}
          onCancel={() => setPreviewOpen(false)}
          centered
          width="auto"
          styles={{ body: { padding: 8, display: 'flex', justifyContent: 'center', alignItems: 'center' } }}
          title={altText}
          footer={
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <Button icon={<DownloadOutlined />} onClick={handleDownload}>
                Download
              </Button>
              <Button type="primary" onClick={() => setPreviewOpen(false)}>
                Close
              </Button>
            </div>
          }
        >
          <img
            src={imageUrl}
            alt={altText}
            style={{ maxWidth: '80vw', maxHeight: '70vh', objectFit: 'contain', borderRadius: 8 }}
          />
        </Modal>
      )}
    </>
  );
};
